<div class="container">
  <h2>Assign Parent Referral</h2>

  <div>
    <label>Parent Mobile Number:</label>
    <input
      [(ngModel)]="parentMobile"
      (blur)="findParentInfo()"
      placeholder="Enter parent mobile number"
    />
  </div>

  <div *ngIf="parentReferralCode">
    <p><strong>Referral Code:</strong> {{ parentReferralCode }}</p>
    <p><strong>Parent Name:</strong> {{ parentName }}</p>
  </div>

  <div>
    <label>Child Mobile Number:</label>
    <input
      [(ngModel)]="childMobile"
            (blur)="findChildInfo()"
      placeholder="Enter child mobile number"
    />
  </div>
<div *ngIf="childName">
    <p><strong>Child Name:</strong> {{ childName }}</p>
  </div>

  <button (click)="assignReferral()" class="success">Assign Referral Code to Child</button>

  <p class="message">{{ message }}</p>
</div>
